import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=106fdb1c&"
import script from "./GameContainer.vue?vue&type=script&lang=js&"
export * from "./GameContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports